/* eslint-disable jsx-a11y/anchor-is-valid */

import React from 'react';
import { useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import MenuItem from '../MenuItem';
import { PurchaseOrdersIcon, TemplatesIcon } from '../../../bombiix-icon';

function ComponentOrderUrl({ isMobileMenu }) {
  const reducer = useSelector((reducerstate) => reducerstate);
  const {
    UserDetails: { isSupplierLoggedIn },
  } = reducer;

  const history = useHistory();
  const pathName = history.location.pathname;
  return (
    <ul>
      {!isSupplierLoggedIn && (
        <>
          <MenuItem
            activeClassList={['/component-order/purchase-order']}
            pathName={pathName}
            linkTo="/component-order/purchase-order"
            IconComponent={PurchaseOrdersIcon}
            titleKey="PURCHASE_ORDERS.PURCHASE_ORDER"
            isMobileMenu={isMobileMenu}
          />
          <MenuItem
            activeClassList={['/component-order/po-template']}
            pathName={pathName}
            linkTo="/component-order/po-template"
            IconComponent={TemplatesIcon}
            titleKey="PURCHASE_ORDERS.PO_TEMPLATE"
            isMobileMenu={isMobileMenu}
          />
        </>
      )}
    </ul>
  );
}

export default ComponentOrderUrl;
